export default "__VITE_ASSET__BT_8Q4vw__"